var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2004",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41422",
    "data-name": "Group 41422",
    transform: "translate(11886 3988)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15702",
    "data-name": "Rectangle 15702",
    width: 16,
    height: 16,
    transform: "translate(-11886 -3988)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1998",
    transform: "translate(-11885 -3304.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2000",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2008",
    transform: "translate(0.547 0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2010",
    d: "M-308.213,0a6.453,6.453,0,0,0-6.453,6.453,6.453,6.453,0,0,0,6.453,6.453,6.453,6.453,0,0,0,6.453-6.453A6.453,6.453,0,0,0-308.213,0Z",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2012",
    transform: "translate(4.539 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2014",
    d: "M0,0H4.922",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleOutlined);
export default __webpack_public_path__ + "static/media/minus-circle-outlined.96d0ce8045cd261e917cec77a1375565.svg";
export { ForwardRef as ReactComponent };